import React, { Component } from 'react';
import api from '../../configs/api';

class ResetPasswordRequest extends Component {
  constructor() {
    super();

    this.state = {
      email: '',
      success: false,
      userNotFound: false,
      emailNotValid: false,
      fail: false,
    };
  }

  handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
    });
  }

  submitForm(e) {
    e.preventDefault();

    api.resetPasswordRequest(this.state.email).then(
      () => {
        this.setState({
          success: true,
        });
      },
      response => {
        if (response.status === 404 || response.status === 400) {
          this.setState({
            userNotFound: response.status === 404,
            emailNotValid: response.status === 400,
          });
        } else {
          this.setState({
            fail: true,
          });
        }
      }
    )
  }

  reset() {
    this.setState({
      email: '',
      success: false,
      userNotFound: false,
      emailNotValid: false,
      fail: false,
    });
  }

  render() {
    return (
      <div>
        <div className='header_sub'>
          <p>Password Reset - Authentication</p>
        </div>

        {!this.state.userNotFound && !this.state.fail && !this.state.success && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2>Password Reset for ISAAC</h2>
              <p>Before being able to reset your password we need to authenticate you as a user.</p>
              <p>
                <strong>Step 1</strong> - Please enter your email address below.</p>
              <p>
                <strong>Step 2</strong> - You will then be sent an email with a link.</p>
              <p>
                <strong>Step 3</strong> - Click on this link and you will be returned here to enter a new password.</p>
              <form onSubmit={this.submitForm.bind(this)} noValidate>
                <label>Enter your email address</label>
                {this.state.emailNotValid && <p className='error'>Please enter a valid email address.</p>  }              
                <input
                  value={this.state.email}
                  type='text'
                  placeholder='youremail@warner.com'
                  onChange={this.handleChange.bind(this, 'email')} />
                <input type='submit' disabled={!this.state.email} title='Submit' />
              </form>
            </div>
          </div>
        </div>}


        {this.state.userNotFound && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2 className='error'>Error</h2>
              <p><strong>Your email was not part of the ISAAC user groups. You will not be able to proceed any further.</strong></p>
              <p>If you believe that you are part of the ISAAC system and your email should have been included, please contact your system administrator.</p>
              <button onClick={this.reset.bind(this)}>Back</button>
            </div>
          </div>
        </div>}


        {this.state.fail && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2 className='error'>Error</h2>
              <p><strong>Please try again.</strong></p>
              <button onClick={this.reset.bind(this)}>Back</button>
            </div>
          </div>
        </div>}

        {this.state.success && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2>Thank you.</h2>
              <p>You have been sent an email. This email contains a link. Please click on this and follow the instructions to reset your password.</p>
              <button onClick={this.reset.bind(this)}>Back</button>
            </div>
          </div>
        </div>}

      </div>
    );
  }
}

export default ResetPasswordRequest;
